import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import {
  convertRegexFilterToBooleanFilter,
  convertRegexFilterToStartsWithFilter,
} from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';
import {
  ExchangeAntimalwareExclusionRule,
  ExchangeAntimalwareRule,
  ExchangeRuleScopeApplyToType,
  ExchangeRuleScopeEmailSelection,
} from '@nirvana/shared/dtos/types/policies/common';
import { sortByColumn } from './utils/sorters';

export interface ExchangeAntimalwareExclusionFrontendFields extends ExchangeAntimalwareExclusionRule {
  applyTo: ExchangeRuleScopeApplyToType;
  senders: ExchangeRuleScopeEmailSelection;
  recipients: ExchangeRuleScopeEmailSelection;
}

export class GzExchangeAntimalwareExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeAntimalwareExclusionRule
> {
  sortByColumnMethod(
    a: ExchangeAntimalwareExclusionFrontendFields,
    b: ExchangeAntimalwareExclusionFrontendFields,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert to boolean
    convertRegexFilterToBooleanFilter(request, ColumnKeys.STATUS);

    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.NAME);
    return;
  }

  protected getItemsWithAdditionalFrontendFields(
    items: ExchangeAntimalwareRule[]
  ): ExchangeAntimalwareExclusionFrontendFields[] {
    return items.map(item => {
      return {
        ...item,
        applyTo: item.scope.applyTo,
        senders: item.scope.from,
        recipients: item.scope.to,
      };
    });
  }
}
